import { useMutation } from '@tanstack/react-query';
import { Divider, Empty, Flex, List, Typography } from 'antd';
import { useContext } from 'react';
import { getTicketFile } from 'src/apis/helpdesk/ticket.api';
import Download from 'src/assets/icons/download.png';
import RightIcon from 'src/assets/icons/right.png';
import LeftIcon from 'src/assets/icons/left.png';
import Icon from 'src/components/v2/Icon';
import { AppContext } from 'src/contexts/app.context';
import { TicketDetailContext } from 'src/contexts/ticketDetail.context';
import { ITicketFile, TicketFileAdd } from 'src/types/helpdesk/ticket.type';
import ProcessTree from '../ProcessTree';
import './TicketDetail.scss';
const { Link, Text } = Typography;

export default function TicketDetailSidebar() {
  const { isDetailSidebarCollapsed, isTicketDetailCollapsed, setIsDetailSidebarCollapsed } = useContext(AppContext);
  const { ticket } = useContext(TicketDetailContext);

  const handleCollapseSider = () => {
    setIsDetailSidebarCollapsed(!isDetailSidebarCollapsed);
  };

  const ticketFileMutation = useMutation({
    mutationFn: (ticketFile: TicketFileAdd) => getTicketFile(ticketFile)
  });

  const handleReviewFile = (ticketFile: ITicketFile) => {
    ticketFileMutation.mutate(ticketFile, {
      onSuccess: (data) => {
        const url = window.URL.createObjectURL(
          new Blob([data.data], {
            type: `${ticketFile.contentType};charset=UTF-8 `
          })
        );
        window.open(url, '_blank');
      }
    });
  };

  const handleDownloadFile = (ticketFile: ITicketFile) => {
    ticketFileMutation.mutate(
      {
        filePath: ticketFile.filePath,
        originalName: ticketFile.originalName
      },
      {
        onSuccess: (data) => {
          const url = window.URL.createObjectURL(
            new Blob([data.data], {
              type: `${ticketFile.contentType};charset=UTF-8 `
            })
          );
          const link = document.createElement('a');
          link.href = url;
          document.body.appendChild(link);
          link.setAttribute('download', ticketFile?.originalName ?? 'file');
          link.click();
        }
      }
    );
  };

  return (
    <div className='ticket-detail-sidebar'>
      <Flex className='hide-icon' justify='left' onClick={handleCollapseSider}>
        {/* <Icon
          url={isDetailSidebarCollapsed ? LeftIcon : RightIcon}
          size={20}
          titleTooltip={isDetailSidebarCollapsed ? 'Mở cây phê duyệt' : 'Đóng'}
          placementTooltip='bottom'
          open={isDetailSidebarCollapsed && !isTicketDetailCollapsed ? true : false}
        /> */}
        <div className='menu-button menu-button-open' onClick={handleCollapseSider}>
          <Icon
            url={isDetailSidebarCollapsed ? LeftIcon : RightIcon}
            size={20}
            titleTooltip={isDetailSidebarCollapsed ? 'Mở cây phê duyệt' : 'Đóng'}
            placementTooltip='bottom'
            open={isDetailSidebarCollapsed && !isTicketDetailCollapsed ? true : false}
          />
        </div>
      </Flex>
      <Flex className='ticket-detail-sidebar-content'>
        {!isDetailSidebarCollapsed && (
          <Flex
            gap={30}
            vertical
            style={{
              width: '100%'
            }}
          >
            <ProcessTree />
            <Flex vertical gap={5}>
              <Divider style={{ marginBlock: 0 }} orientation='left'>
                <Text strong>Tệp đính kèm</Text>
              </Divider>
              <List
                bordered={false}
                split={false}
                className='ticket-detail-attachment'
                itemLayout='horizontal'
                locale={{
                  emptyText: (
                    <Empty
                      image='https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg'
                      description={<Text type='secondary'>Không có tệp đính kèm</Text>}
                    />
                  )
                }}
                dataSource={ticket?.data.ticketFiles}
                renderItem={(item, index) => (
                  <List.Item
                    actions={[
                      <Icon
                        url={Download}
                        onClick={() => {
                          handleDownloadFile({
                            filePath: item.filePath,
                            originalName: item.originalName,
                            contentType: item.contentType
                          } as ITicketFile);
                        }}
                        size={20}
                        titleTooltip='Download'
                      />
                    ]}
                  >
                    <List.Item.Meta
                      description={
                        <Link
                          onClick={() =>
                            handleReviewFile({
                              filePath: item.filePath,
                              originalName: item.originalName,
                              contentType: item.contentType
                            } as ITicketFile)
                          }
                        >
                          {item.originalName}
                        </Link>
                      }
                    />
                  </List.Item>
                )}
              />
            </Flex>
          </Flex>
        )}
      </Flex>
    </div>
  );
}
